export interface IDeleteRedisInvalidateCache {
    method: string;
    ono: number;
    ano: number;
}
